<section
  class="analysis-stage-section"
  [class.is-expanded]="expanded"
  [attr.data-cy]="'stage-' + stage.name"
  [attr.data-status]="stage.isCompleted ? 'completed' : 'pending'">
  <button
    type="button"
    class="analysis-stage-section__header"
    [attr.aria-expanded]="expanded"
    (click)="toggleStage.emit()">
    <span class="analysis-stage-section__caret" aria-hidden="true">
      <i class="pi" [class.pi-chevron-down]="expanded" [class.pi-chevron-right]="!expanded"></i>
    </span>

    <h2 class="analysis-stage-section__title">{{ stageLabel }}</h2>

    <span class="analysis-stage-section__badges">
      <span class="analysis-stage-section__badge is-pending" *ngIf="metrics.pending > 0">
        {{ metrics.pending }} {{ metrics.pending === 1 ? 'pendente' : 'pendentes' }}
      </span>

      <span class="analysis-stage-section__badge is-rejected" *ngIf="metrics.rejected > 0">
        {{ metrics.rejected }} {{ metrics.rejected === 1 ? 'rejeitado' : 'rejeitados' }}
      </span>

      <span class="analysis-stage-section__approved" *ngIf="hasSubmissions">
        {{ metrics.approved }}/{{ metrics.submitted }} aprovados
      </span>

      <span class="analysis-stage-section__approved" *ngIf="!hasSubmissions">sem envios</span>
    </span>
  </button>

  <div class="analysis-stage-section__body" *ngIf="expanded">
    <app-analysis-document-row
      *ngFor="let requiredDocument of stage.requiredDocuments"
      [documentLabel]="labelFor(requiredDocument)"
      [requiredDocument]="requiredDocument"
      [submissionTooltips]="submissionTooltips"
      [analysisTooltips]="analysisTooltips"
      [statusLabels]="statusLabels"
      [noDocumentSentLabel]="noDocumentSentLabel"
      (documentSelected)="documentSelected.emit({ document: $event, requiredDocument })">
    </app-analysis-document-row>
  </div>
</section>
